import React from 'react';
import { Invoice } from '../../../../redux/billing/billing.types';
import { formatCurrency } from './utils';
import { Equal, X } from 'lucide-react';

interface InvoiceDetailCalcProps {
  invoice: Invoice;
}

export const InvoiceDetailCalc: React.FC<InvoiceDetailCalcProps> = ({
  invoice,
}) => {
  const calculateMargin = () => {
    const spend = invoice.invoice_line_items.reduce((acc, item) => acc + (item.advertiser_spend || 0), 0);
    const marginPct = invoice.invoice_line_items.reduce((acc, item) => acc + (item.margin_pct || 0), 0);
    return spend * (marginPct / 100);
  };
  const calculateRate = (invoice: Invoice) => {
    const qty = invoice.invoice_line_items.filter(item => !item.do_not_bill && !item.hide).reduce((acc, item) => acc + (item.qty == 1 ? 1 : item.qty / 1000), 0);
    return invoice.invoice_line_items.filter(item => !item.do_not_bill && !item.hide).reduce((acc, item) => acc + (item.amount_to_bill || 0), 0) / qty;
  };

  const calculateQty = (invoice: Invoice) => {
    return invoice.invoice_line_items.filter(item => !item.do_not_bill && !item.hide).reduce((acc, item) => acc + (item.qty == 1 ? 1 : item.qty / 1000), 0);
  };

  return (
    <>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-gray-500'>
          Total
        </div>
        <div className='text-xl font-thin'>
          {invoice.invoice_line_items.filter(item => !item.do_not_bill && !item.hide).reduce((acc, item) => acc + (item.qty == 1 ? 1 : item.qty / 1000), 0).toFixed(0)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Qty
        </div>
      </div>
      <div>
        <X className='h-4 w-4' />
      </div>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent'>
          {'L'}
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(calculateRate(invoice))}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Rate
        </div>
      </div>
      <div>
        <Equal className='h-4 w-4' />
      </div>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent'>
          {'L'}
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(calculateRate(invoice) * (calculateQty(invoice)))}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Total
        </div>
      </div>
    </>
  );
};

export default InvoiceDetailCalc;
